import { useTranslation } from "react-i18next";

/** The lead times the backend accepts, in hours before the start. */
export const REMINDER_LEAD_HOURS: readonly number[] = [2, 6, 12, 24, 48];

interface SessionRemindersSettingsProps {
  enabled: boolean;
  leadHours: number;
  disabled: boolean;
  onChange: (enabled: boolean, leadHours: number) => void;
}

/**
 * The organization's session reminders (PD-0020): on by default at 24 hours, the
 * owner picks the lead time or switches them off. Members keep their own opt-out.
 */
const SessionRemindersSettings = ({ enabled, leadHours, disabled, onChange }: SessionRemindersSettingsProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-5 border-t border-grey-90 pt-4 dark:border-primary-30">
      <h3 className="text-base font-semibold text-grey-20 dark:text-white">
        {t("website.portalFeatures.remindersTitle", "{{Session}} reminders")}
      </h3>
      <label className="mt-3 flex cursor-pointer items-start gap-3">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={enabled}
          disabled={disabled}
          onChange={() => onChange(!enabled, leadHours)}
        />
        <span>
          <span className="block text-sm font-medium text-grey-20 dark:text-white">
            {t("website.portalFeatures.remindersSwitch", "Send reminder emails")}
          </span>
          <span className="block text-xs text-grey-40 dark:text-grey-80">
            {t(
              "website.portalFeatures.remindersHint",
              "One email before each booked date, with the free-cancellation deadline if there is one. {{Members}} can turn them off in their portal.",
            )}
          </span>
        </span>
      </label>
      <label className="mt-3 ml-6 block text-sm font-medium text-grey-30 dark:text-grey-70">
        {t("website.portalFeatures.remindersLead", "Send")}
        <select
          className="input mt-1 w-full sm:w-80"
          value={leadHours}
          disabled={disabled || !enabled}
          onChange={(event) => onChange(enabled, Number(event.target.value))}
        >
          {REMINDER_LEAD_HOURS.map((hours) => (
            <option key={hours} value={hours}>
              {t("website.portalFeatures.remindersLeadOption", "{{hours}} hours before", { hours })}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default SessionRemindersSettings;
